import { PropertyService } from '@modules/property/property-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';


export class PropertyField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/property',
      Permissions.values.propertyRead,
      PropertyService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
          roles: record.roles  ?  record.roles : []

        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/property',
      
      Permissions.values.propertyRead,
      PropertyService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }
   
        return {
          id: record.id,
          label: record.name,
          roles:  []
        };
      },
      options,
    );
  }
}
